import HamptonAvenue1 from '../../../Media/Ruko Paramount/Hampton Avenue/Hampton Avenue (1).webp'
import HamptonAvenue2 from '../../../Media/Ruko Paramount/Hampton Avenue/Hampton Avenue (2).webp'

const HamptonAvenueimages =[
HamptonAvenue1,HamptonAvenue2
]

export default HamptonAvenueimages;
